module.exports = __webpack_public_path__ + "static/img/product-1.b45b3e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-1.png
// module id = LzNN
// module chunks = 0